import { forwardRef, useEffect, useState } from "react";
import styles from "./References.module.sass";
import cn from "classnames";
import { useAppSelector } from "toolkit/hooks";
import CustomLinkForAccept from "components/CustomLink";
import {userAPI} from "../../libs/apiClient/User";
import {organizationsAPI} from "../../libs/apiClient/Organizations";

const dependencies = [
	"dictionary.okved.read",
	"dictionary.organization_marker.read",
	"dictionary.threat.read",
	"dictionary.object_status.read",
	"dictionary.inapplicability_reason.read",
	"dictionary.object_type.read",
	"dictionary.significance_criteria.read",
	"dictionary.ownership_type.read",
	"dictionary.activity_area.read",
	"dictionary.threat_consequence.read",
	"dictionary.person_status.read",
	"dictionary.construction_objects.read",
	"dictionary.document_patterns.read",
	"dictionary.business_process_pattern.read",
	"system.user_dictionary.read",
	"system.employee_dictionary.read",
	"system.organization.read",
	"dictionary.threat_model_template.read",
];

export const References = forwardRef<any, any>(({ close }, ref) => {
	const [open, setOpen] = useState(false);

	const [accept, setAccept] = useState({
		"dictionary.okved.read": false,
		"dictionary.organization_marker.read": false,
		"dictionary.threat.read": false,
		"dictionary.object_status.read": false,
		"dictionary.inapplicability_reason.read": false,
		"dictionary.object_type.read": false,
		"dictionary.significance_criteria.read": false,
		"dictionary.ownership_type.read": false,
		"dictionary.activity_area.read": false,
		"dictionary.threat_consequence.read": false,
		"dictionary.person_status.read": false,
		"dictionary.construction_objects.read": false,
		"dictionary.document_patterns.read": false,
		"dictionary.business_process_pattern.read": false,
		"system.user_dictionary.read": false,
		"system.employee_dictionary.read": false,
		"system.organization.read": false,
		"dictionary.threat_model_template.read": false,
	});

	const referencesInfoOfCompleting = useAppSelector((state) => state.references.references);

	const profile = useAppSelector((state) => state.profile.profile);

	const [organizationListPatterns, setOrganizationListPatterns] = useState(false);

	useEffect(() => {
		if (profile && profile.id) {
			userAPI.permissionsCheckCreate(profile.organization?.id || 0, dependencies).then((r) => {
				if (r && r.data.length) {
					setAccept((prevState) => {
						const newState = { ...prevState };
						r.data.forEach((_: string) => {
							const key = _ as keyof typeof newState;
							newState[key] = true;
						});
						return newState;
					});
				}
			});
		}
		organizationsAPI.documentPatternsList({page:1,num:5}).then(({ data }) =>
			setOrganizationListPatterns(!!data.length),
		);
		//eslint-disable-next-line
	}, []);
	console.log(referencesInfoOfCompleting)
	return (
		<div ref={ref} className={styles.references}>
			<div className={styles["list-fix"]}>
				<div className={styles["list-fix__fix"]}>
					<p className={styles.title}>Основные справочники</p>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["system.organization.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.organisationsPresent}
						url={`/organizations`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.structure, styles.icon)} />
							Организации
						</div>
					</CustomLinkForAccept>
					{/*<Link onClick={close} to={``} className={styles.link}></Link>*/}
					{/*<Link onClick={close} to={`/`} className={styles.link}></Link>*/}
					{/*<CustomLinkForAccept linkClick={close} switched={accept["system.employee_dictionary.read"]}*/}
					{/*                     linkStyle={styles.link} url={`/`}>*/}
					{/*   <div></div> Субъекты КИИ*/}
					{/*</CustomLinkForAccept>*/}
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["system.employee_dictionary.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.employeesPresent}
						url={`references/staff`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.employees, styles.icon)} />
							Сотрудники
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["system.user_dictionary.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.usersPresent}
						url={`references/users`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.users, styles.icon)} />
							Пользователи
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={profile.admin}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.rolesPresent}
						url={`/settings/roles`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.roles, styles.icon)} />
							Настройка ролей
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.okved.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.okvedCodesPresent}
						url={`references/codes`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.okved, styles.icon)} />
							Коды ОКВЭД
						</div>
					</CustomLinkForAccept>
				</div>
				<button onClick={() => setOpen((prevState) => !prevState)} className={styles.btn}>
					{open ? "Свернуть" : "Развернуть"}
				</button>
			</div>
			<div className={cn(styles.wrap, styles[`wrap-${open}`])}>
				<p className={styles.title}>Дополнительные справочники</p>
				<div className={cn(styles.list)}>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.activity_area.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.activityAreasPresent}
						url={`references/areas-activity`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.areasActivity, styles.icon)} />
							Сферы деятельности
						</div>
					</CustomLinkForAccept>
					{/*<CustomLinkForAccept linkClick={close} url={`/`} linkStyle={styles.link}>*/}
					{/*    <div><TypesOfActivity/></div>*/}
					{/*    Виды деятельности*/}
					{/*</CustomLinkForAccept>*/}
					{/*<Link onClick={close} to={`/`} className={styles.link}>Роли участников комиссий</Link>*/}
					{/*<Link onClick={close} to={`/`} className={styles.link}><Templates/> Шаблоны перечней бизнес-процессов</Link>*/}
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.ownership_type.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.ownershipTypesPresent}
						url={`references/ownerships`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.ownership, styles.icon)} />
							Виды владения
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.document_patterns.read"] || organizationListPatterns}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.documentPatternsPresent}
						url={`references/document-templates`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.templates, styles.icon)} />
							Шаблоны документов организаций
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.person_status.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.personStatusesPresent}
						url={`references/statuses-employee`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.statusEmployee, styles.icon)} />
							Статусы сотрудников
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.construction_objects.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.constructionObjectsPresent}
						url={`references/register_of_kapstroy_objects`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.kapstroy, styles.icon)} />
							Объекты Капитального строительства
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.organization_marker.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.orgMarkersPresent}
						url={`references/markers`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.markers, styles.icon)} />
							Маркеры организаций
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.object_status.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.objectStatusesPresent}
						url={`references/object-statuses`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.objectStatuses, styles.icon)} />
							Статусы объектов
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.object_type.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.objectTypesPresent}
						url={`references/objects`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.objects, styles.icon)} />
							Типы объектов
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.threat_consequence.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.threatConsequencesPresent}
						url={`references/consequences_of_the_implementation_of_threats`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.consequences, styles.icon)} />
							Последствия реализации угроз
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.threat.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.threatsPresent}
						url={`references/threats`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.threats, styles.icon)} />
							Угрозы
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.inapplicability_reason.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.inapplicabilityReasonsPresent}
						url={`references/reasons_for_the_inapplicability`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.reasons, styles.icon)} />
							Причины неприменимости показателей критериев значимости
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.significance_criteria.read"]}
						linkStyle={styles.link}
						isFilled={!referencesInfoOfCompleting.significanceCriteriaPresent}
						url={`references/indicators_of_significance_criteria`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.indicators, styles.icon)} />
							Показатели критериев значимости
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.business_process_pattern.read"]}
						linkStyle={styles.link}
						isFilled={false}
						url={`references/business_process_registry`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.BP, styles.icon)} />
							Шаблоны реестра бизнес-процессов
						</div>
					</CustomLinkForAccept>
					<CustomLinkForAccept
						linkClick={close}
						switched={accept["dictionary.threat_model_template.read"]}
						linkStyle={styles.link}
						isFilled={false}
						url={`references/threat-pattern`}>
						<div className={styles.boxIcon}>
							<div className={cn(styles.modelThreat, styles.icon)} />
							Шаблоны модели угроз
						</div>
					</CustomLinkForAccept>
				</div>
			</div>
		</div>
	);
});
